/**
 * Column definitions for the Events table.
 *
 * Follows the same `{ id, property, label }` pattern used by
 * `src/containers/pages/customers/data/headTableCells.ts`.
 *
 * Columns with `property: ''` render no `TableSortLabel`; all others
 * support sort-on-click via `handler.onSort(cell.property)`.
 */
export const eventsHeadTableCells = [
  { id: 1, property: '', label: '' },                   // checkbox column -- no sort
  { id: 2, property: 'camera_name', label: 'Camera' },  // camera name + site subtitle
  { id: 3, property: 'severity', label: 'Severity' },   // SeverityChip
  { id: 4, property: 'created_at', label: 'Detected' }, // relative time via getTimeAgo()
  { id: 5, property: 'status', label: 'Status' },       // StatusChip
];
